import instance from "./axios.base";

const getFamilyMembers = async () => {
  const res = await instance.get("/service?name=who&tablename=hr_emp_family");
  return res.data;
};

export { getFamilyMembers };
